module.exports = __webpack_public_path__ + "img/28800.c1e5b1ce.jpg";